// eslint-disable-next-line no-shadow

enum ActionTypes {
  START_UPLOAD_CV_LIST = "START_UPLOAD_CV_LIST",
  SUCCESS_UPLOAD_CV_LIST = "SUCCESS_UPLOAD_CV_LIST",
  END_UPLOAD_CV_LIST = "END_UPLOAD_CV_LIST",
}

export default ActionTypes;
